import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';
import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  private http = inject(HttpClient);

  public getAllBySubArea(subAreaId: number): Observable<Dtos.Facility[]> {
    return this.http.get<Dtos.Facility[]>(`${environment.apiUrl}/facility/getBySubArea/${subAreaId}`);
  }

  public getFacilityById(id: number): Observable<Dtos.Facility> {
    return this.http.get<Dtos.Facility>(`${environment.apiUrl}/facility/${id}`);
  }

  public createFacility(facility: Dtos.Facility): Observable<Dtos.Facility> {
    return this.http.post<Dtos.Facility>(`${environment.apiUrl}/facility`, facility);
  }

  public updateFacility(facility: Dtos.Facility): Observable<Dtos.Facility> {
    return this.http.put<Dtos.Facility>(`${environment.apiUrl}/facility`, facility);
  }

  public deleteFacility(id: number): Observable<Dtos.Facility> {
    return this.http.put<Dtos.Facility>(`${environment.apiUrl}/facility/delete/${id}`, null);
  }

  public activateFacility(id: number): Observable<Dtos.Facility> {
    return this.http.put<Dtos.Facility>(`${environment.apiUrl}/facility/${id}/activate`, null);
  }
}
